import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Button } from "../../../components/ui/button";

async function loadStaticManifest(courseSlug) {
  const base = process.env.PUBLIC_URL || "";
  const url = `${base}/resources/${encodeURIComponent(courseSlug)}.json`;
  try {
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    return data;
  } catch (e) {
    return null;
  }
}

export default function PreviewPage() {
  const { slug } = useParams();
  const [manifest, setManifest] = useState(null);
  const [loading, setLoading] = useState(Boolean(slug));
  // Allow direct previews passed via sessionStorage (from lesson examples)
  const [incomingSrcDoc, setIncomingSrcDoc] = useState(null);

  useEffect(() => {
    try {
      const doc = sessionStorage.getItem('preview:incomingSrcDoc');
      if (doc) {
        setIncomingSrcDoc(doc);
        sessionStorage.removeItem('preview:incomingSrcDoc');
      }
    } catch (e) {
      // ignore
    }
  }, []);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      const m = await loadStaticManifest(slug);
      if (!mounted) return;
      setManifest(m);
      setLoading(false);
    })();
    return () => { mounted = false; };
  }, [slug]);

  if (!slug) return <div className="container py-8">No course specified.</div>;
  if (loading) return <div className="container py-8">Loading preview…</div>;

  // Build an HTML document for the iframe
  const previewHtml = (manifest && (manifest.previewHtml || manifest.sampleHtml || manifest.html || "")) || "";
  const previewCss = (manifest && (manifest.previewCss || manifest.sampleCss || manifest.css || "")) || "";
  const title = manifest?.title || slug;

  const srcDoc = `<!doctype html><html><head><meta charset=\"utf-8\" /><meta name=\"viewport\" content=\"width=device-width,initial-scale=1\" /><title>${title} - Preview</title><style>${previewCss}</style></head><body>${previewHtml}</body></html>`;

  return (
    <div className="container py-8">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-bold">Preview: {title}</h1>
        <div className="flex gap-3">
          <Link to={`/courses/${slug}`}>
            <Button variant="outline">Course Overview</Button>
          </Link>
          <Link to={`/courses/${slug}/resources`}>
            <Button variant="outline">Resources</Button>
          </Link>
        </div>
      </div>

      {incomingSrcDoc ? (
        <div className="border rounded-md overflow-hidden">
          <iframe id="course-preview-iframe" title="Preview" srcDoc={incomingSrcDoc} style={{ width: "100%", height: "70vh", border: 0 }} />
        </div>
      ) : previewHtml || previewCss ? (
        <div className="border rounded-md overflow-hidden">
          <iframe id="course-preview-iframe" title="Preview" srcDoc={srcDoc} style={{ width: "100%", height: "70vh", border: 0 }} />
        </div>
      ) : (
        <div className="rounded-md border p-4">
          <p className="mb-2">No preview content available for this course.</p>
          <p className="text-sm text-muted-foreground">Check the course resources or open the course overview for more information.</p>
        </div>
      )}
    </div>
  );
}
